import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation } from 'react-query';
import { useToastError } from 'lib/hooks';
import { useTranslation } from 'react-i18next';
import { successToast } from 'lib/components/toasts/success';
import { useHistory } from 'react-router';

interface IVideoUploadRequest {
  description: string;
  title: string;
  videoId: number;
  privacyStatus: string;
  code: string;
}

interface IVideoUploadResponse {
  success: boolean;
  channelUrl?: string;
}

const uploadVideo = async (
  body: IVideoUploadRequest
): Promise<IVideoUploadResponse> => {
  return (
    await EXPRESS_API.post<IVideoUploadResponse>('/youtube/video-upload', body)
  ).data;
};

export const useVideoUploadMutation = () => {
  const { showError } = useToastError();
  const history = useHistory();
  const { t } = useTranslation();
  return useMutation(uploadVideo, {
    onSuccess: (data: IVideoUploadResponse) => {
      if (!!data.success) {
        successToast({ title: 'Video uploaded successfully to YouTube!' });
        if (!!data.channelUrl?.length) {
          window.open(data.channelUrl, '_blank');
        }

        history.push('/home');
      }
    },
    onError: e => {
      showError(
        e,
        t(
          'There was a problem in uploading video to youtube. Please try again.'
        )
      );
    },
  });
};
